import React, { useEffect, useMemo, useState } from 'react'
import { AuthenticateDocument } from '../../utils/AuthenticateDocument';
import MainLayout from '../MainLayout';
import External from '../ExternalUser';
import { useDocument } from '../../Pages/SpreadsheetContainer/documentInfoContex';
import { useParams } from 'react-router-dom';
import { hasCachedDocument } from '../../utils/documentCache';

const MileGrid = ({ isExternal = false, isTemplateDocument = false }) => {

    const { id } = useParams();
    const { conflictPreviewVerion, setConflictPreviewVerion, setIsReadOnly, setIsTemplateDocument } = useDocument();
    const [isAuthenticating, setIsAuthenticating] = useState(true);

    // Cached documents render instantly (no auth loader); only non-templates cache.
    const isDocumentCached = useMemo(
        () => !isTemplateDocument && hasCachedDocument(id),
        [id, isTemplateDocument]
    );

    useEffect(() => {
        setIsTemplateDocument(isTemplateDocument);
        const searchParams = new URLSearchParams(document.location.search)
        const previewVerion = searchParams.get("versionType");
        if (previewVerion) {
            setConflictPreviewVerion(previewVerion);
            setIsReadOnly(true);
        }

    }, [id]);

    return (
        <div className='App'>
            {isExternal ? (
                <External />
            ) : isAuthenticating && !conflictPreviewVerion && !isDocumentCached ? (
                <AuthenticateDocument setIsLoading={setIsAuthenticating} />
            ) : (
                <>
                    <MainLayout />
                    {/* Cached doc: authenticate in the background (no loader) while cached data shows. */}
                    {isDocumentCached && isAuthenticating && !conflictPreviewVerion && (
                        <AuthenticateDocument setIsLoading={setIsAuthenticating} background />
                    )}
                </>
            )}
        </div>
    )
}

export default MileGrid;